var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOuze(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 987.49 240.73",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M121.08,0C54.13,0,0,54.13,0,120.37,0,187,54.13,240.73,121.08,240.73S242.16,187,242.16,120.37C242.16,54.13,188,0,121.08,0m0,199.78c-43.8,0-78.7-35.61-78.7-79.41a78.7,78.7,0,1,1,157.4,0c0,43.8-34.9,79.41-78.7,79.41",
    className: "le_color_01"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M464.34,122.86c0,44.87-26.71,76.92-70.51,76.92S323,167.73,323,122.86V4.27h-42v120c0,64.46,46.29,116.45,112.89,116.45,66.23,0,112.88-52,112.88-116.45V4.27H464.34Z",
    className: "le_color_01"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "545.89 4.27 545.89 45.23 661.27 45.23 544.46 176.28 544.46 237.53 580.91 196.58 752.08 4.27 545.89 4.27",
    className: "le_color_01"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FF00FF",
    points: "544.46 237.53 736.76 237.53 736.76 196.58 580.91 196.58 544.46 237.53",
    className: "le_color_02"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF00FF",
    d: "M867.46,0C804.07,0,749.23,54.13,749.23,120.37c0,69.08,57,119.3,124.64,119.3H876v-41h-2.14c-39.53,0-73-25.28-80.13-63H987.47C988.54,53.77,944,0,867.46,0m-73,97.58c8.54-35.26,38.1-57.34,74.78-57.34,37,0,65.52,22.08,71.22,57.34Z",
    className: "le_color_02"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOuze);
export default __webpack_public_path__ + "static/media/ouze.24061ca16e04a98b2d3405252dc631da.svg";
export { ForwardRef as ReactComponent };